@if (!loading) {
  <div>
    @if (providerOffices.length === 0) {
      <div>There are no providers for this office.</div>
    }
    @if (providerOffices.length > 0) {
      <table class="table w-100">
        <thead class="table-dark">
          <tr>
            <th>ID</th>
            <th>NPI</th>
            <th class="text-nowrap">Provider Name</th>
            <th>Specialties</th>
            <th>Provider Fax Status</th>
            <th>Association Note</th>
          </tr>
        </thead>
        <tbody>
          @for (providerOffice of providerOffices; track providerOffice) {
            <tr>
              <td>{{ providerOffice.provider.id }}</td>
              <td>
                <a
                  routerLink="/capture-admin/providers/{{providerOffice.provider.npi}}"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  target="_blank">
                  {{ providerOffice.provider.npi }}
                  <app-copy-to-clipboard [text]="providerOffice.provider.npi" />
                </a>
              </td>
              <td>{{ providerOffice.provider.fullName }}</td>
              <td>
                <app-specialty-badges [specialties]="providerOffice.provider.specialties" [showBlank]="true" />
              </td>
              <td class="status-column">
                <app-provider-office-fax-status [providerOffice]="providerOffice" />
              </td>
              <td class="small notes-column">
                <app-notes-for-model
                  [model]="providerOffice"
                  [modelType]="'ProviderOffice'"
                  [minimizeControls]="true"
                  />
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
} @else {
  <mat-spinner />
}

